import { render, staticRenderFns } from "./WibaComponent.vue?vue&type=template&id=5f9a456d&scoped=true&"
import script from "./WibaComponent.vue?vue&type=script&lang=js&"
export * from "./WibaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a456d",
  null
  
)

export default component.exports